export const UPDATE_COUNTRY = "UPDATE_COUNTRY";
export const UPDATE_LANGUAGE = "UPDATE_LANGUAGE";
export const INFO_ENTERED = "INFO_ENTERED";

export const MAILING_ADDRESS_ENTERED = "MAILING_ADDRESS_ENTERED";
export const MAILING_ADDRESS_REQUESTED = "MAILING_ADDRESS_REQUESTED";
export const SUGGESTED_MAILING_ADDRESS_REQUESTED_SUCCESS = "SUGGESTED_MAILING_ADDRESS_REQUESTED_SUCCESS";
export const SUGGESTED_MAILING_ADDRESS_REQUESTED_FAIL = "SUGGESTED_MAILING_ADDRESS_REQUESTED_FAIL";

export const SUBMIT_PRIVACY_REQUEST = "SUBMIT_PRIVACY_REQUEST";

export const TIER_UPDATE = "TIER_UPDATE";
export const STATE_SELECTOR =
{
    STATE_SELECTOR_LOAD: 'STATE_SELECTOR_LOAD',
    STATE_SELECTOR_FAIL: 'STATE_SELECTOR_FAIL',
    STATE_SELECTOR_SUCCESS: 'STATE_SELECTOR_SUCCESS',
    STATE_SELECTOR_RESET: 'STATE_SELECTOR_RESET'
}

export const STATUS_FORM =
{
    STATUS_FORM_DETAILS: 'STATUS_FORM_DETAILS',
    STATUS_FORM_FAIL: 'STATUS_FORM_FAIL',
    STATUS_FORM_SUCCESS: 'STATUS_FORM_SUCCESS',
    GET_DOC_STORE_REPORT : 'GET_DOC_STORE_REPORT',
    GET_VWGOA_DOCUMENT : 'GET_VWGOA_DOCUMENT',
    RESET_FORM : 'RESET_FORM'
}

export const REQUEST_SELECTOR =
{
    REQUEST_SELECTOR_LOAD: 'REQUEST_SELECTOR_LOAD',
    REQUEST_SELECTOR_FAIL: 'REQUEST_SELECTOR_FAIL',
    REQUEST_SELECTOR_SUCCESS: 'REQUEST_SELECTOR_SUCCESS',
    REQUEST_SELECTOR_RESET: 'REQUEST_SELECTOR_RESET'
}

export const VERIFICATION_FORM = 
{
 VERIFICATION_FORM_DETAILS : "VERIFICATION_FORM_DETAILS",
 VERIFICATION_FORM_SUCCESS : "VERIFICATION_FORM_SUCCESS",
 VERIFICATION_FORM_FAIL : "VERIFICATION_FORM_FAIL",
}

export const EXPERIAN_FORM =
{
    GET_EXPERIAN_DETAILS : "GET_EXPERIAN_DETAILS",
    GET_EXPERIAN_SUCCESS : "GET_EXPERIAN_SUCCESS",
    GET_EXPERIAN_FAIL : "GET_EXPERIAN_FAIL",
    VERIFY_EXPERIAN_DETAILS : "VERIFY_EXPERIAN_DETAILS",
    VERIFY_EXPERIAN_SUCCESS : "VERIFY_EXPERIAN_SUCCESS",
    VERIFY_EXPERIAN_FAIL : "VERIFY_EXPERIAN_FAIL"
}

export const PROTECTION_SERVICES_EXPERIAN_FORM =
{
    GET_PROTECTION_SERVICES_EXPERIAN_DETAILS : "GET_PROTECTION_SERVICES_EXPERIAN_DETAILS",
    GET_PROTECTION_SERVICES_EXPERIAN_DETAILS_CHECK_MY_REQUESTS : "GET_PROTECTION_SERVICES_EXPERIAN_DETAILS_CHECK_MY_REQUESTS",
    GET_PROTECTION_SERVICES_EXPERIAN_SUCCESS : "GET_PROTECTION_SERVICES_EXPERIAN_SUCCESS",
    GET_PROTECTION_SERVICES_EXPERIAN_FAIL : "GET_PROTECTION_SERVICES_EXPERIAN_FAIL",
    VERIFY_PROTECTION_SERVICES_EXPERIAN_DETAILS : "VERIFY_PROTECTION_SERVICES_EXPERIAN_DETAILS",
    VERIFY_PROTECTION_SERVICES_EXPERIAN_DETAILS_CHECK_MY_REQUESTS : "VERIFY_PROTECTION_SERVICES_EXPERIAN_DETAILS_CHECK_MY_REQUESTS",
    VERIFY_PROTECTION_SERVICES_EXPERIAN_SUCCESS : "VERIFY_PROTECTION_SERVICES_EXPERIAN_SUCCESS",
    VERIFY_PROTECTION_SERVICES_EXPERIAN_FAIL : "VERIFY_PROTECTION_SERVICES_EXPERIAN_FAIL",
    CLEAR_DETAILS : "CLEAR_DETAILS"
}

export const RIGHT_TO_CORRECT = 
{
    UPDATE_NAME : "UPDATE_NAME",
    CLEAR_UPDATED_NAME : "CLEAR_UPDATED_NAME",
    UPDATE_EMAIL: "UPDATE_EMAIL",
    CLEAR_UPDATED_EMAIL : "CLEAR_UPDATED_EMAIL",
    UPDATE_PHONE_NUMBER: "UPDATE_PHONE_NUMBER",
    CLEAR_UPDATED_PHONE_NUMBER : "CLEAR_UPDATED_PHONE_NUMBER",
    UPDATE_ADDRESS: "UPDATE_ADDRESS",
    CLEAR_UPDATED_ADDRESS : "CLEAR_UPDATED_ADDRESS",
    SUGGESTED_CORRECTED_ADDRESS_REQUESTED_SUCCESS : "SUGGESTED_CORRECTED_ADDRESS_REQUESTED_SUCCESS",
    SUGGESTED_CORRECTED_ADDRESS_REQUESTED_FAIL : "SUGGESTED_CORRECTED_ADDRESS_REQUESTED_FAIL",
    CLEAR_ALL : "CLEAR_ALL",
}
export const SECURE_KEY = 
{
    GET_USER_DETAILS : "GET_USER_DETAILS",
    GET_USER_SUCCESS : "GET_USER_SUCCESS",
    GET_USER_FAIL : "GET_USER_FAIL",
    GET_URL : "GET_SECURE_KEY_URL",
    VERIFICATION_FORM_DETAILS : "SECURE_KEY_VERIFICATION_FORM_DETAILS",
    VERIFICATION_FORM_SUCCESS : "SECURE_KEY_VERIFICATION_FORM_SUCCESS",
    VERIFICATION_FORM_FAIL : "SECURE_KEY_VERIFICATION_FORM_FAIL",
}
